// Les fiches d'infos pays sont servies sur le sous-domaine BeTravel.
// Le champ `url_infos` renvoyé par le backend pointe encore vers
// l'ancien domaine `visamonde.com` : on réécrit le domaine à la volée.
const INFOS_PAYS_DOMAIN = 'https://betraveling.visamonde.com';

/**
 * Réécrit le domaine d'une URL d'infos pays vers le sous-domaine BeTravel.
 * Ex. `https://visamonde.com/Egypte.html` -> `https://betraveling.visamonde.com/Egypte.html`.
 * Idempotent : une URL déjà sur `betraveling.visamonde.com` est inchangée.
 */
export const toInfosPaysUrl = (urlInfos: string): string =>
  urlInfos.replace(/^https?:\/\/(www\.)?visamonde\.com/i, INFOS_PAYS_DOMAIN);
